import ActivityLogsUserSupportPage from "../../../component/users/support/ActivityLogsUserSupport"

 
 
function ActivityLogsUserSupport() {
  return (
    <div className="page-body"><ActivityLogsUserSupportPage/></div>
  )
}

export default ActivityLogsUserSupport